var link_preview_default = {
  "fontElementMap": "eyDYz",
  "linkPreviewContainer": "Pe7JM",
  "linkPreview": "oTY5S",
  "linkPreviewImage": "uvc8l",
  "linkPreviewPlaceholder": "L3E-9",
  "linkPreviewInfo": "OHzRy",
  "linkPreviewTitle": "ltXSm",
  "linkPreviewDescription": "iMmba",
  "linkPreviewUrl": "_5Tvad",
  "linkPreviewResponsiveImage": "tGJcW",
  "loadingContainer": "eGB3n",
  "errorIcon": "_4wd4k",
  "errorInfo": "fFiBC",
  "errorContainer": "MT5Og",
  "overlay": "_7WdcL",
  "thumbnailEnd": "_9V2BD",
  "thumbnailStart": "GYRrR",
  "thumbnailTop": "Bp2vD"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
